<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="text" class="text-xs text-gray-800 md:text-sm rich-text" v-html="richTextToHtmlString(text, links)" />
</template>

<script setup lang="ts">
import type { TextBlock, TextBlockRestAPI } from '@/types/contentful';

type Props = {
  content?: TextBlockRestAPI | { textBlock: TextBlock };
};

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

const text = computed(
  () =>
    (props.content as TextBlockRestAPI)?.fields?.bodyTextSecondary ||
    (props.content as unknown as { textBlock: TextBlock })?.textBlock?.bodyTextSecondary?.json,
);

// GraphQL has a link property since it doesn't automatically resolve links
const links = computed(
  () => (props.content as unknown as { textBlock: TextBlock })?.textBlock?.bodyTextSecondary.links,
);
</script>

<script lang="ts">
export default defineComponent({
  name: 'TextBlock',
});
</script>

<style lang="scss">
.rich-text table {
  table-layout: fixed;
  min-width: initial;
  margin-left: auto;
  margin-right: auto;
}

.rich-text td {
  width: 200px;
}
</style>
